import { createApiRef } from '@backstage/core-plugin-api';
import type { AuditApi } from './types';

export const auditApiRef = createApiRef<AuditApi>({
  id: 'plugin.service-catalog-audit.api',
});
